import zIndex from "@mui/material/styles/zIndex";
import React, { useEffect, useRef, useState } from "react";
import { Circle, Rect, Layer, Line, Stage, Image } from "react-konva";
import Swal from "sweetalert2";
import useImage from "use-image";
import mapCenterIcon from "./img/home.png"


function Anchor(props) {
  const [strokeWidth, setStrokeWidth] = useState(2);
  // Detect if device is mobile/touch
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || 
                   ('ontouchstart' in window) || 
                   (navigator.maxTouchPoints > 0);
  // Larger radius for mobile devices
  const radius = isMobile ? 25 : 15;

  const handleClick = () => {
    document.body.style.cursor = "default";
    props.onClick();
  };

  return (
    <Circle
      x={props.point.x}
      y={props.point.y}
      radius={radius}
      stroke="#666"
      fill={props.fill}
      strokeWidth={strokeWidth}
      onMouseOver={() => {
        if (!isMobile) {
          document.body.style.cursor = "pointer";
          setStrokeWidth(3);
        }
        if (props.onMouseOver) props.onMouseOver();
      }}
      onMouseOut={() => {
        if (!isMobile) {
          document.body.style.cursor = "default";
        }
        setStrokeWidth(2);
        if (props.onMouseOut) props.onMouseOut();
      }}
      onClick={handleClick}
      onTap={handleClick}
      // Increase hit area for better touch interaction
      hitStrokeWidth={isMobile ? 10 : 5}
    />
  );
}

function PolygonOriginAnchor(props) {
  const isValid = props.validateMouseEvents();
  const [fill, setFill] = useState("transparent");

  const handleClick = () => {
    if (isValid) {
      props.onValidClick();
    }
  };

  const handleMouseOver = () => {
    if (isValid) {
      document.body.style.cursor = "pointer";
      setFill("green");
      if (props.onValidMouseOver) props.onValidMouseOver();
    } else {
      document.body.style.cursor = "not-allowed";
      setFill("red");
    }
  };

  const handleMouseOut = () => {
    setFill("transparent");
  };

  return (
    <Anchor
      point={props.point}
      fill={fill}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  );
}

function PolygonConstructor({childRef , data  , onPolygonCompletion , drawing , poly , removed , containerWidth , containerHeight }) {
  
  const [polygons, setPolygons] = useState([]);
  const [currentPolygon, setCurrentPolygon] = useState([]);
  const [nextPoint, setNextPoint] = useState({ x: 0, y: 0 });
  const [showPreviewLine, setShowPreviewLine] = useState(false);
  const mapRef = useRef(null);
  // Track touch events to distinguish tap from drag
  const touchStartPos = useRef(null);
  const touchStartTime = useRef(null);
  const isDragging = useRef(false);
  const lastClickTime = useRef(0);
  const lastClickPos = useRef(null);
  // Detect if device is mobile/touch
  const isMobileDevice = useRef(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || 
    ('ontouchstart' in window) || 
    (navigator.maxTouchPoints > 0)
  );
  
  const handleClick = ({ x, y }, isTouch = false) => {
    if(!drawing){
      setCurrentPolygon([])
      return 
    }
    
    // Prevent duplicate clicks/taps (within 300ms and 10px distance)
    // Only apply this check for touch events to avoid blocking desktop clicks
    if (isTouch) {
      const now = Date.now();
      if (lastClickPos.current) {
        const distance = Math.sqrt(
          Math.pow(x - lastClickPos.current.x, 2) + 
          Math.pow(y - lastClickPos.current.y, 2)
        );
        if (now - lastClickTime.current < 300 && distance < 10) {
          return; // Ignore duplicate event
        }
      }
      lastClickTime.current = now;
      lastClickPos.current = { x, y };
    }
    
    // Only add point if it wasn't a drag (only relevant for touch events)
    if (!isTouch || !isDragging.current) {
      setCurrentPolygon([...currentPolygon, { x, y }]);
      // Hide preview line after adding a point
      setShowPreviewLine(false);
    }
  };

  const handleCompletePolygon = () => {
    if (!data || !data.color || !data.zone) {
      console.error("Missing zone/color data before completing polygon");
      return;
    }

    setPolygons([
      ...polygons,
      {
        shape_points: currentPolygon,
        color: data.color || "red",
        zone_name: data.zone?.zone_name || "N/A",
        zone_decoder: data.zone?.decoder || "",
        position: currentPolygon[0]
          ? { x: currentPolygon[0].x, y: currentPolygon[0].y }
          : { x: 0, y: 0 },
      },
    ]);
    childRef(mapRef.current);
    setCurrentPolygon([]);
    setShowPreviewLine(false);
    onPolygonCompletion();
  };
  useEffect(() => {

    if(removed){
      setPolygons(poly)

    }
  
   
  
    }, [removed,poly]);
  

   
  return (
    <>
      {polygons.length > 0? 
      
      polygons.map((polygon, index) => (
        <Line
        ref={childRef}
          key={index}
          
          opacity={0}
          zIndex={0}
          points={polygon.shape_points.flatMap((point) => [point.x, point.y])}
         
        />
      )) : null}

      {/* Línea que conecta los puntos ya agregados del polígono */}
      {currentPolygon.length > 1 && (
        <Line
          strokeWidth={3}
          stroke="blue"
          points={currentPolygon.flatMap((point) => [point.x, point.y])}
        />
      )}
      
      {/* Línea de vista previa desde el último punto hasta el cursor */}
      {showPreviewLine && currentPolygon.length > 0 && (
        <Line
          strokeWidth={3}
          stroke="blue"
          strokeDasharray={[5, 5]}
          points={[
            currentPolygon[currentPolygon.length - 1].x,
            currentPolygon[currentPolygon.length - 1].y,
            nextPoint.x,
            nextPoint.y
          ]}
        />
      )}
      
      {/* Puntos visuales en cada posición del polígono */}
      {currentPolygon.map((point, index) => (
        <Circle
          key={`point-${index}`}
          x={point.x}
          y={point.y}
          radius={5}
          fill="blue"
          stroke="white"
          strokeWidth={2}
        />
      ))}

      <Rect
        x={0}
        y={0}
        width={containerWidth || window.innerWidth}
        height={containerHeight || 800}
        onClick={(event) => {
          // Handle mouse clicks on desktop
          // Skip if this is a touch device (will be handled by onTap)
          if (isMobileDevice.current) {
            return;
          }
          
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          if (pointerPos) {
            handleClick({ x: pointerPos.x, y: pointerPos.y }, false);
          }
        }}
        onTap={(event) => {
          // Handle touch taps - only if it wasn't a drag
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          
          if (pointerPos) {
            // Check if this was actually a drag by comparing with touch start position
            if (touchStartPos.current) {
              const distance = Math.sqrt(
                Math.pow(pointerPos.x - touchStartPos.current.x, 2) + 
                Math.pow(pointerPos.y - touchStartPos.current.y, 2)
              );
              // Only treat as tap if movement was minimal (< 10px) and not marked as drag
              if (distance < 10 && !isDragging.current) {
                handleClick({ x: pointerPos.x, y: pointerPos.y }, true);
              }
            } else if (!isDragging.current) {
              // Fallback if touchStartPos is not available
              handleClick({ x: pointerPos.x, y: pointerPos.y }, true);
            }
          }
        }}
        onMouseMove={(event) => {
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          if (pointerPos && currentPolygon.length > 0) {
            setNextPoint({ x: pointerPos.x, y: pointerPos.y });
            setShowPreviewLine(true);
          } else if (pointerPos && currentPolygon.length === 0) {
            // Actualizar nextPoint incluso si no hay puntos aún, para cuando se agregue el primero
            setNextPoint({ x: pointerPos.x, y: pointerPos.y });
          }
        }}
        onTouchStart={(event) => {
          // Track touch start position and time
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          if (pointerPos) {
            touchStartPos.current = { x: pointerPos.x, y: pointerPos.y };
            touchStartTime.current = Date.now();
            isDragging.current = false;
            // Update nextPoint but don't show preview line until movement is detected
            setNextPoint({ x: pointerPos.x, y: pointerPos.y });
            setShowPreviewLine(false);
          }
        }}
        onTouchMove={(event) => {
          // Update nextPoint and show preview line when user is moving
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          
          if (pointerPos && touchStartPos.current) {
            // Calculate distance moved
            const distance = Math.sqrt(
              Math.pow(pointerPos.x - touchStartPos.current.x, 2) + 
              Math.pow(pointerPos.y - touchStartPos.current.y, 2)
            );
            
            // If moved more than 3px, consider it intentional movement and show preview line
            if (distance > 3 && currentPolygon.length > 0) {
              isDragging.current = true;
              setNextPoint({ x: pointerPos.x, y: pointerPos.y });
              setShowPreviewLine(true);
            } else if (distance > 3) {
              // Update nextPoint even if no points yet
              setNextPoint({ x: pointerPos.x, y: pointerPos.y });
            }
          } else if (pointerPos && currentPolygon.length > 0) {
            // Fallback: update if touchStartPos is not available
            setNextPoint({ x: pointerPos.x, y: pointerPos.y });
            setShowPreviewLine(true);
          }
        }}
        onTouchEnd={(event) => {
          // Check final distance to determine if it was a tap or drag
          const stage = event.target.getStage();
          const pointerPos = stage.getPointerPosition();
          const now = Date.now();
          
          if (pointerPos && touchStartPos.current) {
            const finalDistance = Math.sqrt(
              Math.pow(pointerPos.x - touchStartPos.current.x, 2) + 
              Math.pow(pointerPos.y - touchStartPos.current.y, 2)
            );
            
            // If moved less than 10px and was quick (< 300ms), it was a tap
            if (finalDistance < 10 && touchStartTime.current && (now - touchStartTime.current) < 300) {
              // It was a tap, ensure dragging is false
              isDragging.current = false;
              setShowPreviewLine(false);
            } else if (finalDistance >= 10) {
              // It was a drag, keep preview line visible briefly then hide
              setTimeout(() => {
                setShowPreviewLine(false);
              }, 200);
            } else {
              // Reset state
              isDragging.current = false;
              setShowPreviewLine(false);
            }
          } else {
            // Reset state
            isDragging.current = false;
            setShowPreviewLine(false);
          }
          
          // Clear touch tracking after a short delay to allow onTap to check
          setTimeout(() => {
            touchStartPos.current = null;
            touchStartTime.current = null;
          }, 100);
        }}
      />

      {currentPolygon.length > 0 && (
        <PolygonOriginAnchor
          props
          point={currentPolygon[0]}
          onValidClick={handleCompletePolygon}
          onValidMouseOver={() => setNextPoint(currentPolygon[0])}
          validateMouseEvents={() => currentPolygon.length > 2}
        />
      )}
    </>
  );
}

// Helper function to create pin icon SVG URL
const createPinIconUrl = (color = '#032C65') => {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" height="44" viewBox="0 0 24 24" width="44">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="${color}"/>
    </svg>
  `;
  const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
  return URL.createObjectURL(blob);
};

export default function PolygonMaker({
  img,
  childR,
  data,
  containerWidth,
  containerHeight,
  polygons,
  clickMarkers,
  dialogAction,
  drawing,
  removed,
  poly_completed,
  imageMarkers,
  selectedMarker,
  controllerPinSitePlan,
  onMarkersUpdate,
  onImageInfo,
  selectedMarkerIdFromParent = null,
}) {

  const [points, setPoints] = useState([]);
  const [image] = useImage(img); 
  const [controllerIcon] = useImage(mapCenterIcon)
  const [selectedMarkerId, setSelectedMarkerId] = useState(selectedMarkerIdFromParent);
  const [decoders,setdecoders] = useState([])
  const [polygonCompleted, setPolygonCompleted] = useState(false); 
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [scaledSize, setScaledSize] = useState({ width: 0, height: 0 });
  const [scaleFactor, setScaleFactor] = useState({ x: 1, y: 1 });
  // Store initial position when drag starts to detect if it was intentional
  const dragStartPositions = useRef({});
  
  // Create pin icon URLs for selected and unselected states
  const [pinIconUrl] = useState(() => createPinIconUrl('#032C65'));
  const [pinIconSelectedUrl] = useState(() => createPinIconUrl('red'));
  const [pinIcon] = useImage(pinIconUrl);
  const [pinIconSelected] = useImage(pinIconSelectedUrl);
  
  // Calculate scaled image dimensions to fit container while maintaining aspect ratio
  useEffect(() => {
    if (image && containerWidth > 0 && containerHeight > 0) {
      const imageAspectRatio = image.width / image.height;
      const containerAspectRatio = containerWidth / containerHeight;
      
      let scaledWidth, scaledHeight;
      
      if (imageAspectRatio > containerAspectRatio) {
        // Image is wider - fit to width
        scaledWidth = containerWidth;
        scaledHeight = containerWidth / imageAspectRatio;
      } else {
        // Image is taller - fit to height
        scaledHeight = containerHeight;
        scaledWidth = containerHeight * imageAspectRatio;
      }
      
      setImageSize({
        width: image.width,
        height: image.height
      });
      
      setScaledSize({
        width: scaledWidth,
        height: scaledHeight
      });
      
      setScaleFactor({
        x: scaledWidth / image.width,
        y: scaledHeight / image.height
      });
      
      // Calculate image offset for centering
      const imageX = (containerWidth - scaledWidth) / 2;
      const imageY = (containerHeight - scaledHeight) / 2;
      
      // Notify parent component about image dimensions for coordinate conversion
      // Use ORIGINAL image dimensions for percentage calculations (more stable across devices)
      if (onImageInfo) {
        onImageInfo({
          originalWidth: image.width,
          originalHeight: image.height,
          scaledWidth: scaledWidth,
          scaledHeight: scaledHeight,
          imageX: imageX,
          imageY: imageY
        });
      }
    } else if (!image && containerWidth > 0 && containerHeight > 0) {
      // No image, use container dimensions
      setScaledSize({
        width: containerWidth,
        height: containerHeight
      });
      setScaleFactor({ x: 1, y: 1 });
    }
  }, [image, containerWidth, containerHeight]);

  const makePoints = (e) =>{
    const target = e.target;
    const stage = target.getStage();
    const className = target.getClassName();
    
    // Don't add points if clicking on interactive elements
    // Markers and controller pins are draggable Images, polygons are Lines with opacity 0.5
    if (className === 'Image' && target.draggable()) {
      // This is a marker or controller pin, don't add point
      return;
    }
    if (className === 'Line' && target.opacity() === 0.5) {
      // This is a polygon, don't add point
      return;
    }
    
    // Add point when clicking on background (image, rect, stage, or layer)
    clickMarkers(e);
    const pointerPos = stage.getPointerPosition();
    if (pointerPos) {
      const x = pointerPos.x;
      const y = pointerPos.y;
      setPoints([...points, { x, y }])
    }
  } 

const select = (e, poly) => {
  if (e) {
    e.cancelBubble = true;
    if (e.evt) {
      e.evt.stopPropagation();
    }
  }
  dialogAction(poly)
}


const handleDragStartMarkers = (index, e) => {
  setdecoders(index);
  // Save initial position to detect if drag was intentional
  const initialPos = {
    x: e.target.x(),
    y: e.target.y()
  };
  dragStartPositions.current[index] = initialPos;
};

const handleDragMoveMarkers = (index, e) => {
  // Just track which marker is being dragged, don't update state during drag
  // This prevents React from re-rendering and resetting the position
  if (decoders !== index) {
    setdecoders(index);
  }
};
const handleDragEndMarkers = (index, e) => {
  // Get final position from the dragged element
  const finalPos = {
    x: e.target.x(),
    y: e.target.y()
  };
  
  // Get initial position
  const initialPos = dragStartPositions.current[index];
  
  // Calculate distance moved
  const distance = Math.sqrt(
    Math.pow(finalPos.x - initialPos.x, 2) + 
    Math.pow(finalPos.y - initialPos.y, 2)
  );
  
  // Threshold: if movement is less than 5 pixels, treat it as a click, not a drag
  const DRAG_THRESHOLD = 5;
  
  if (distance < DRAG_THRESHOLD && initialPos) {
    // Movement was too small, restore original position
    e.target.x(initialPos.x);
    e.target.y(initialPos.y);
    // Don't update the marker position in state
    setdecoders(null);
    delete dragStartPositions.current[index];
    return;
  }
  
  // Movement was significant, allow the drag
  // Update the marker position in the array
  const updatedMarkers = imageMarkers.map((marker, i) => 
    i === index 
      ? { ...marker, position: finalPos }
      : marker
  );
  
  // Update parent's imageMarkers state with final position
  if (onMarkersUpdate) {
    onMarkersUpdate(updatedMarkers);
  }
  
  setdecoders(null);
  delete dragStartPositions.current[index];
};

const handlePolygonCompletion = () => {

  setPolygonCompleted(true);
  poly_completed();

}

const handleDragController = (index,e) => {
  const newPos = {
    x: e.target.x(),
    y: e.target.y()
  };
  const updtController = [...controllerPinSitePlan];
  updtController[index].position = newPos;
  

}

const selectMarker = (e,marker) => {
  e.cancelBubble = true;
  e.evt.stopPropagation();
  setSelectedMarkerId(marker.id);
  selectedMarker(e,marker)
}

// Sincronizar selectedMarkerId con el estado del padre
useEffect(() => {
  setSelectedMarkerId(selectedMarkerIdFromParent);
}, [selectedMarkerIdFromParent]);


  // Use scaled dimensions for stage, or container dimensions if no image
  const stageWidth = image && scaledSize.width > 0 ? scaledSize.width : containerWidth;
  const stageHeight = image && scaledSize.height > 0 ? scaledSize.height : containerHeight;
  
  // Calculate offset to center the image in the container
  const imageX = image && scaledSize.width > 0 ? (containerWidth - scaledSize.width) / 2 : 0;
  const imageY = image && scaledSize.height > 0 ? (containerHeight - scaledSize.height) / 2 : 0;
  
  return (
    <Stage
    width={containerWidth || stageWidth}
    height={containerHeight || stageHeight}
    ref={childR}
    onClick={makePoints}
    onTap={makePoints}
  >


  <Layer   >


   
    {image && scaledSize.width > 0 && scaledSize.height > 0 && (
    <Image
    image={image}
    width={scaledSize.width}
    height={scaledSize.height}
    x={imageX}
    y={imageY}
  />
    )}


 
  

     <PolygonConstructor
      data={data}
      poly={polygons}
      childRef={childR}
      points={points}
      drawing={drawing}
      removed={removed}
      onPolygonCompletion={handlePolygonCompletion}
      containerWidth={containerWidth}
      containerHeight={containerHeight}
    />
{polygons.map((polygon, index) => (
      <Line
        key={index}
        zIndex={1}
        strokeWidth={3}
        stroke={polygon.color}
        fill={polygon.color}
        opacity={0.5}
        closed
        onClick={(e) => select(e, polygon)}
        onTap={(e) => select(e, polygon)}
        points={polygon.shape_points.flatMap((point) => point)}

      />
    ))}


{imageMarkers.map((marker, index) => {
  const isSelected = selectedMarkerId === marker.id;
  return (
    <Image
      key={marker.id || index}
      image={isSelected ? pinIconSelected : pinIcon}
      x={marker.position.x}
      y={marker.position.y}
      width={44}
      zIndex={125}
      height={44}
      draggable={!isSelected}
      onClick={(e) => selectMarker(e, marker)}
      onTap={(e) => selectMarker(e, marker)}
      onDragStart={!isSelected ? (e) => handleDragStartMarkers(index, e) : undefined}
      onDragMove={!isSelected ? (e) => handleDragMoveMarkers(index, e) : undefined}
      onDragEnd={!isSelected ? (e) => handleDragEndMarkers(index, e) : undefined}
    />
  );
})}




{controllerPinSitePlan !== null  ? controllerPinSitePlan.map((controller, index) => (

 
  
  
<Image
  key={index}
  image={controllerIcon}
  x={controller.position.x}
  y={controller.position.y}
  width={44}
  zIndex={15 }
  onDragMove={(e)=> handleDragController(index,e)}

  height={44}
  draggable
   />




     )) : ""}
       
       
    

   

  </Layer>
</Stage>
  );

}
